// Configuration with runtime support

// Runtime configuration that can be injected at runtime
interface RuntimeConfig {
  ENVIRONMENT?: string;
  VERSION?: string;
  BUILD_NUMBER?: string;
  BUILD_DATE?: string;
}

// Extend window interface to include runtime config
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

// Get runtime config from window object if available
const runtimeConfig: RuntimeConfig = window.__RUNTIME_CONFIG__ || {};

import { getFeatureFlag } from './featureFlags';

export const isMockoonEnabled = () => getFeatureFlag('useMockoon');

export const isApplicationFilterEnabled = () =>
  import.meta.env.VITE_REACT_APP_SHOW_SUBMITTED_APPS !== 'TRUE';

/** Cloudflare Turnstile site key; empty turns the widget off. Read per call so tests can stub it. */
export const turnstileSiteKey = (): string =>
  (import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '').trim();

export const config = {
  apiUrl:
    (isMockoonEnabled()
      ? import.meta.env.VITE_REACT_MOCKOON_API
      : import.meta.env.VITE_REACT_APP_API) || 'https://localhost:23866/api',
  environment:
    runtimeConfig.ENVIRONMENT || import.meta.env.MODE || 'development',
  version: runtimeConfig.VERSION || import.meta.env.VITE_APP_VERSION || 'local',
  buildNumber: runtimeConfig.BUILD_NUMBER || 'local',
  buildDate: runtimeConfig.BUILD_DATE || new Date().toISOString(),
};

// Helper functions
export const isDevelopment = () => config.environment === 'development';
export const isTesting = () => config.environment === 'testing';
export const isStaging = () => config.environment === 'staging';
export const isProduction = () => config.environment === 'production';

export const isAllUnlocked = () => getFeatureFlag('unlockAll');

export const isMPIEnabled = () => !getFeatureFlag('disableMPI');

export const isAllUsersUnlocked = () => getFeatureFlag('unlockAllUsers');
export const isDevToolsEnabled =
  import.meta.env.VITE_REACT_APP_SHOW_DEV_TOOLS === 'TRUE';
